// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"promotion_wrapper__wBsTX","container":"promotion_container__9mf5j","body":"promotion_body__VbpI_"};